import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import messages_en from "./lang/en-US.json";

function LocaleProvider({ children }) {
  const [language, setLanguage] = useState("en-US");

  useEffect(() => {}, []);

  return (
    <IntlProvider locale={language} messages={messages_en}>
      {children}
    </IntlProvider>
  );
}

export default LocaleProvider;
